/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Plan_BodyInputs */

const en_portal_view_plan_body = /** @type {(inputs: Portal_View_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You tick off sets at the gym. Your coach sees how much you did and adds more when you're ready.`)
};

const pl_portal_view_plan_body = /** @type {(inputs: Portal_View_Plan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhaczasz serie na sali. Trener widzi, ile zrobiłeś, i dokłada, kiedy jesteś gotowy.`)
};

/**
* | output |
* | --- |
* | "You tick off sets at the gym. Your coach sees how much you did and adds more when you're ready." |
*
* @param {Portal_View_Plan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_plan_body = /** @type {((inputs?: Portal_View_Plan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Plan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_plan_body(inputs)
	return en_portal_view_plan_body(inputs)
});